import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Layout from "./Layout";
import MixcloudPlayer from "./MixcloudPlayer";
// import PhotoGalleryMasonry from "./PhotoGalleryMasonry";
// import BandsInTownEvents from './BandsInTownEvents';
import Styles from "../../public/assets/css/main.css";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

const Show = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const { showId } = useParams();
  const [show, setShow] = useState(null);
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (context) {
      // context.updateBreadcrumbsState([]);
    }

    const fetchShows = async () => {
      try {
        const nocache = new Date().getTime();
        const response = await fetch(`/shows.json?nocache=${nocache}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setShows(data);
        setShow(data.find(s => s.id === showId));
      } catch (e) {
        console.error("Error fetching shows:", e);
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    // fetchShows();
  }, []);

  return (
    <Layout>
      <MixcloudPlayer
        sourceUrl={`https://www.mixcloud.com/merkurio/${showId}/`}
      />
      {/* <Box sx={{ flexGrow: 1 }}>
        <PhotoGalleryMasonry images={show ? show.images : []} />
      </Box> */}
    </Layout>
  );
};

export default Show;
